import {register} from '@shopify/theme-sections';
import tingle from 'tingle.js';


import $, {type} from 'jquery';
import {util} from '../lib/util';
import {rechargeUtil} from '../lib/rechargeUtil';
import {animations} from '../lib/animations';
import {processSelectPlanKeyPress} from '../lib/plan-selector';

// import {carousel} from '../lib/carousel.js';
import '../lib/swipe.js';
import packageProtection from '../lib/packageProtection.js';

register('meal-menu', {

  calculateSubscriptionDiscounts(itemCount) {
    const discountingMode = (window.themeConfiguration || {}).planConfiguration;

    if (discountingMode === 'splendid') {
      if (itemCount >= 25) {
        return {discount: 40, shipping: 'free'};
      } else if (itemCount >= 20) {
        return {discount: 25, shipping: 'free'};
      } else if (itemCount >= 14) {
        return {discount: 10, shipping: 'free'};
      } else if (itemCount >= 10) {
        return {discount: 0, shipping: 'free'};
      } else {
        return {discount: 0, shipping: 'not_free'};
      }
    } else if (itemCount >= 18) {
      return {discount: 10, shipping: 'no_change'};
    } else {
      return {discount: 0, shipping: 'no_change'};
    }
  },

  convertCart(cart, addressId, nextChargeDate, frequency, unit, properties) {

    const itemCount = cart.item_count;
    const {discount, shipping} = this.calculateSubscriptionDiscounts(itemCount);

    // handle 18+ cart discount items for bmsm
    const totalDiscount = discount || 0;
    let singleRowItem;
    let discountPerItem = 0;
    let discountLeftover = 0;
    if (totalDiscount > 0) {
      cart.items.map((item) => {
        if (item.quantity === 1) // find last line item as a single so we can stick the remainder on that item
          { singleRowItem = item; }
      });
      if (singleRowItem) {
        discountPerItem = Math.floor((totalDiscount / itemCount) * 100) / 100; // 10 dollars divided by the total items to know how much to modify each item price - round up - we end up with a 10.08 discount
        discountLeftover = totalDiscount - (discountPerItem * itemCount);
      } else {
        discountPerItem = Math.ceil((totalDiscount / itemCount) * 100) / 100; // 10 dollars divided by the total items to know how much to modify each item price - round up - we end up with a 10.08 discount
      }
    }


    const returnCart = cart.items.map((item) => {
      let price = (item.price / 100) - discountPerItem;
      if (item === singleRowItem) { price -= discountLeftover; }

      return {
        address_id: addressId,
        next_charge_scheduled_at: nextChargeDate,
        product_title: item.product_title,
        price,
        quantity: item.quantity,
        shopify_variant_id: item.id,
        order_interval_unit: unit,
        order_interval_frequency: frequency,
        charge_interval_frequency: frequency,
        properties,
      };
    });

    if (cart.getPackageProtection()) {
      const packageProtectionProduct = packageProtection.product;
      const variant = util.getMealsVariant(packageProtectionProduct.variants);
      returnCart.push({
        address_id: addressId,
        next_charge_scheduled_at: nextChargeDate,
        product_title: packageProtectionProduct.product_title,
        price: (packageProtectionProduct.price / 100),
        quantity: 1,
        shopify_variant_id: variant.id,
        order_interval_unit: unit,
        order_interval_frequency: frequency,
        charge_interval_frequency: frequency,
      });
    }

    return {cart: returnCart, shipping};
  },

  async editSubscription(cart, frequency) {
    if (rechargeUtil.bundleMode()) {
      const bundleSelectionItemsPayload = cart.items.map((item) => {
        const product = util.cartItemToProduct(item);
        const payload = util.getBundleSelectionPayload(product);
        return {
          collection_id: payload.collectionId.toString(),
          collection_source: 'shopify',
          external_product_id: payload.externalProductId.toString(),
          external_variant_id: payload.externalVariantId.toString(),
          quantity: item.quantity,
        };
      });

      if (cart.getPackageProtection()) {
        bundleSelectionItemsPayload.push({
          collection_id: window.themeConfiguration.bundleArchitecture.packageProtectionCollectionId.toString(),
          collection_source: 'shopify',
          external_product_id: window.themeConfiguration.packageProtection.product.id.toString(),
          external_variant_id: window.themeConfiguration.packageProtection.product.variantId.toString(),
          quantity: 1,
        })
      }

      const bundleSelection = await rechargeUtil.getBundleSelection();

      const session = await recharge.auth.loginShopifyAppProxy();
      await recharge.bundle.updateBundleSelection(
        session,
        bundleSelection.id,
        { 
          purchase_item_id: bundleSelection.purchase_item_id,
          items: bundleSelectionItemsPayload,
        }
      );
      this.saveCallback();
    } else {
      return this.editSubscriptionLegacy(cart, frequency);
    }
  },

  editSubscriptionLegacy(cart, frequency) {

    const addresses = window.mosaic.recharge.addresses;
    const subscriptions = window.mosaic.recharge.subscriptions;
    let addressId = window.mosaic.recharge.addresses[0].id;

    // Some old customers may have multiple addresses. Pull the address from the
    // subscription instead and hope all subscriptions share the same address.
    if (addresses.length > 1 && subscriptions.length > 0) {
      addressId = subscriptions[0].id;
    }

    let subItems = subscriptions.filter((sub) => sub.status !== 'ONETIME'),
      nextChargeDate = (subItems[0] || {}).next_charge_scheduled_at || util.newChargeDate(),
      planUnit = (subItems[0] || {}).order_interval_unit || 'Weeks',
      planInterval = frequency || (subItems[0] || {}).charge_interval_frequency || '4',
      persistedSubscriptionProperties = (subItems[0] || {}).properties || [],
      convertedCart = this.convertCart(cart, addressId, nextChargeDate, planInterval, planUnit, persistedSubscriptionProperties);


    const response = rechargeUtil.updateAddressSubscriptions(addressId, convertedCart.cart, convertedCart.shipping);
    response.then(this.saveCallback)
      .catch((err) => { console.log('ERROR: ', err.toString()); return this.errorCallback(err); });
  },

  errorCallback(error) {
    util.getErrorLogger().error('Failed to save subscription update.', error);
    util.errorSaveAnimation('.continue-to-checkout-main', 'An Error Occurred');
  },

  saveCallback(response) {
    util.finishSaveAnimation('.continue-to-checkout-main', 'Saved!', 'Back to Account');
    util.returnToPortal();
  },

  expandCartContainer() {
    if (!this.$cartContainer.hasClass('expanded')) {
      this.$cartContainer.addClass('expanded');
      $('body').addClass('cart-expanded');
    }
  },

  contractCartContainer() {
    if (this.$cartContainer.hasClass('expanded')) {
      this.$cartContainer.removeClass('expanded');
      $('body').removeClass('cart-expanded');
    }
  },

  refreshCart(cart, total, orderMin, itemThreshold, itemCount) {
    if (!cart) { return; }
    const frag = document.createDocumentFragment();
    cart.items.forEach((item, index) => {
      const div = document.createElement('DIV');

      // Temporary hack to replace serving sizes with formatted CSS version
      const title = item.product_title.replace(' (4 Servings)', ' <span class="serving-size">(4 Servings)</span>');
      const click_product_id = item.product_id;

      div.innerHTML = `
        <div class="meal-order">
          <div class="placeholder-image" style="background-image: url('${item.image}')"></div>
          <div class="meal-order-name">
            <h3>${title}</h3>
            <div class="meal-order-details">
              <div class="meal-qty">
                <div class="modify">
                  <button class="subtract cart-remove-product modify-meal-quantity" aria-label="Remove 1 ${item.product_title} from cart" data-product-title="${item.product_title}" data-product-id="${click_product_id}" data-minus-one="${index + 1}" data-new-qty="${item.quantity - 1}">–</button>
                  <span class="meal-num">${item.quantity}</span>
                  <button class="add cart-add-product modify-meal-quantity" aria-label="Add 1 ${item.product_title} to cart" data-product-title="${item.product_title}" data-product-id="${click_product_id}" data-plus-one="${index + 1}" data-new-qty="${item.quantity + 1}">+</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        `;

      div.getElementsByClassName('cart-add-product')[0].addEventListener('click', (e) => {
        if (window.basket && this.selectedPlan && window.basket.item_count == this.selectedPlan.itemQuantity) {
          this.productIdToBeAdded = e.currentTarget.dataset.productId;
          e.preventDefault();
          this.showChangePlanModal();
        }
      });
      frag.appendChild(div);
    });

    this.$mealCart.html(frag);

    this.refreshCartButton(total, orderMin, itemThreshold, itemCount);
    this.$cartItemCountContainer.html(`${itemCount.toString()} Items`);
    this.$cartItemCountMobileContainer.html(`${itemCount.toString()} Items`);
    this.$chooseForMeWrapper.attr('qty', itemCount);
    if (this.$cartProgressBarSpan) {
      this.$cartProgressBarSpan.find('.small .bmsm-bar-fill').width(this.getWidthForSection(1, itemCount));
      this.$cartProgressBarSpan.find('.medium .bmsm-bar-fill').width(this.getWidthForSection(2, itemCount));
      this.$cartProgressBarSpan.find('.large .bmsm-bar-fill').width(this.getWidthForSection(3, itemCount));
    }

    if (itemThreshold) {
      this.refreshFamilyMealGauge(itemThreshold, itemCount);
    } else {
      this.refreshShippingGauge(itemCount);
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {$cart: this.$mealCart}));
  },

  getWidthForSection(section, itemCount) {
    const interval = (themeConfiguration || {}).planConfiguration === 'splendid' ? 5 : 6;
    const max = section * interval;
    const min = max - interval + 1;

    const itemCountRange = [];
    for (let i = 0; i <= itemCount; i++) { itemCountRange.push(i); }
    const intervalCount = itemCountRange.reduce((total, i) => ((i >= min && i <= max) ? total + 1 : total), 0);
    if (intervalCount === interval) { return '100%'; }
    return `${intervalCount * (1 / interval).toFixed(2) * 100}%`;
  },

  refreshThresholds() {
    const $form = $('[data-order-min][data-order-max][data-shipping-threshold][data-cfm-threshold]');
    const orderMin = $form.attr('data-order-min');
    const orderMax = $form.attr('data-order-max');
    const chooseForMeThreshold = $form.attr('data-cfm-threshold');
    let itemThreshold = util.getUrlParam('build_to_num');
    if (typeof itemThreshold === 'string') {
      itemThreshold = itemThreshold.replace(/\D/g, '');
    }
    return {
      orderMin,
      orderMax,
      chooseForMeThreshold,
      itemThreshold: Number(itemThreshold),
    };
  },

  refreshFamilyMealGauge(itemThreshold, itemCount) {
    let text = '',
      width = '100%';

    if (itemCount >= itemThreshold) {
      text = 'Box is Full!';
      width = '100%';
      this.$freeShippingProgress.addClass('full');
      this.$freeShippingGaugeWrapper.removeClass('status-orange status-red');
      this.$freeShippingText.addClass('bold');
      this.expandCartContainer();
    } else if (itemCount < itemThreshold) {
      const remainder = ((itemThreshold - itemCount));
      text = `Add <span class="shipping-gauge-remainder">${remainder} meals</span> to check out`;
      width = `${itemThreshold / itemCount * 100}%`;
      this.$freeShippingGaugeWrapper.removeClass('status-orange');
      this.$freeShippingGaugeWrapper.addClass('status-red');
      this.$freeShippingProgress.removeClass('full');
      this.$freeShippingText.removeClass('bold');
    }

    this.$freeShippingText.html(text);
    this.$freeShippingProgress.css('width', width);
  },

  refreshShippingGauge(itemCount) {
    let text = '',
      btnText = '';

    this.$freeShippingGaugeWrapper.show();

    if (this.selectedPlan && !window.shopifyCustomer) { // new users only

      const remainder = (this.selectedPlan.itemQuantity - itemCount);
      if (remainder !== 0) {
        btnText = `Add <strong>${remainder.toString()}</strong> more ${remainder === 1 ? 'item' : 'items'}!`;
      } else { // hide when 0
        btnText = 'Continue';
      }
      this.$cartContinueBtn.html(btnText);
    } else { // existing users
      const displayShipping = window.basket.getDisplayShipping();

      // Note: the discount amounts below need to match: the free shipping
      // auto discount in Shopify, and the monetary discounts hard-coded
      // in the django app in
      // fulfillment.controllers.get_per_meal_discount_splendid and
      // fulfillment.controllers.get_per_meal_discount_mosaic.

      if (themeConfiguration && themeConfiguration.planConfiguration === 'splendid') {

        if (itemCount < 5) {
          // need more to meet min
          text = `<strong>${(5 - itemCount).toString()}</strong> away from minimum order`;
        } else if (itemCount < 10) {
          // x more to free shipping
          const savings = Math.ceil(Number(displayShipping / 100));
          text = `<strong>${(10 - itemCount).toString()}</strong> away from <strong>Free Shipping</strong> ($${savings} Savings)`;
        } else if (itemCount < 14) {
          const discount = 1000;
          const savings = Math.ceil((Number(displayShipping) + Number(discount)) / 100);
          text = `<strong>${(14 - itemCount).toString()}</strong> away from <strong>an extra $${discount / 100} off</strong> ($${savings} total savings)`;
        } else if (itemCount < 20) {
          const discount = 2500;
          const savings = Math.ceil((Number(displayShipping) + Number(discount)) / 100);
          text = `<strong>${(20 - itemCount).toString()}</strong> away from <strong>an extra $${discount / 100} off</strong> ($${savings} total savings)`;
        } else if (itemCount < 25) {
          const discount = 4000;
          const savings = Math.ceil((Number(displayShipping) + discount) / 100);
          text = `<strong>${(25 - itemCount).toString()}</strong> away from <strong>an extra $${discount / 100} off</strong> ($${savings} total savings)`;
        } else if (itemCount <= 28) {
          const discount = 4000;
          const savings = Math.ceil((Number(displayShipping) + discount) / 100);
          text = `<strong>Your Savings: $${savings}</strong>`;
        } else {
          const discount = 4000;
          const savings = Math.ceil((Number(displayShipping) + Number(discount)) / 100);
          text = `<strong>Max Order Size</strong> ($${savings} Savings)`;
        }
      } else if (itemCount < 6) {
          // need more to meet min
        text = `<strong>${(6 - itemCount).toString()}</strong> away from minimum order`;
      } else if (itemCount < 12) {
          // x more to free shipping
        const savings = Math.ceil(Number(displayShipping / 100));
        text = `<strong>${(12 - itemCount).toString()}</strong> away from <strong>Free Shipping</strong> ($${savings} Savings)`;
      } else if (itemCount < 18) {
        const discount = $('#change-content-modal .plan[data-item-quantity=18]').attr('discountAmount') || 1000;
        const savings = Math.ceil((Number(displayShipping) + Number(discount)) / 100);
        text = `<strong>${(18 - itemCount).toString()}</strong> away from <strong>an extra $10 off</strong> ($${savings} total savings)`;
      } else { // 18 (or more?)
        const discount = $('#change-content-modal .plan[data-item-quantity=18]').attr('discountAmount') || 1000;
        const savings = Math.ceil((Number(displayShipping) + Number(discount)) / 100);
        text = `<strong>Max Order Size</strong> ($${savings} Savings)`;
      }
      this.$freeShippingText.html(text);
    }
  },

  selectInitialPlan() {
    if (this.selectedPlan) { this.selectPlan(this.selectedPlan.id); }
  },

  selectPlan(planId) {
    const $section = $('.change-step-plan-selector-v2').last();
    const $selectedPlan = $section.find(`.plan[data-id=${planId}]`);
    const selectedPlanClass = 'selected-plan';
    const selectedIconClass = 'fas fa-check-circle';
    const unselectedIconClass = 'fa fa-circle-thin';
    $selectedPlan.addClass(selectedPlanClass);
    $selectedPlan.trigger('focus');
    $selectedPlan.find('.selection-icon').removeClass(unselectedIconClass);
    $selectedPlan.find('.selection-icon').addClass(selectedIconClass);
    $section.find(`.plan:not([data-id=${planId}])`).each((_i, plan) => {
      $(plan).removeClass(selectedPlanClass);
      $(plan).find('.selection-icon').removeClass(selectedIconClass);
      $(plan).find('.selection-icon').addClass(unselectedIconClass);
    });
    self.selectedPlan = $selectedPlan.data();
  },

  showChangePlanModal() {
    const originalPlan = this.selectedPlan;

    const displayShipping = window.basket.getDisplayShipping();
    $('#change-content-modal .plan').each((_i, plan) => {
      const $plan = $(plan);
      const data = $plan.data();
      const discountAmount = data.discountAmount;

      let savings;
      if (data.itemQuantity === 12) {
        const savings = `$${Math.ceil(Number(displayShipping / 100))} savings`;
        $plan.find('.savings-amount').text(savings);
      }
      if (data.itemQuantity === 18) {
        const savings = `$${Math.ceil(Number((displayShipping + discountAmount) / 100))} savings`;
        $plan.find('.savings-amount').text(savings);
      }

      if (savings) {
        $plan.find('.savings-amount').text(savings);
      }
    });

    const cartCleanup = (useSelected = false) => {
      // remove cart items if needed

      const plan = useSelected ? self.selectedPlan : this.selectedPlan;

      if (window.basket && window.basket.item_count > plan.itemQuantity) {
        let itemsToRemove = window.basket.item_count - plan.itemQuantity;
        if (itemsToRemove <= 0) { return false; }

        // Reverting an upgrade addition if we don't commit to the selected plan
        if (!useSelected && this.productIdToBeAdded) {
          const itemRecentlyAdded = window.basket.items.find((i) => parseInt(i.product_id) === parseInt(this.productIdToBeAdded));
          if (itemRecentlyAdded) {
            window.basket.decrement(itemRecentlyAdded.id);
            itemsToRemove -= 1;
            this.productIdToBeAdded = undefined;
          }
          if (itemsToRemove <= 0) { return false; }
        }

        // most items to least so we remove the least amount of unique items
        window.basket.items.filter((x) => x !== undefined).sort((a, b) => ((a.quantity > b.quantity) ? 1 : -1)).forEach((item) => {
          const product = window.mosaic.products.find((p) => p.id === item.product_id);
          const variant = util.getMealsVariant(product.variants);
          const quantity = item.quantity;
          const properties = item.properties;

          if (quantity > itemsToRemove) {
            // remove partial amount of items and re-add remainder
            window.basket.remove(item.id);
            const newQuantity = quantity - itemsToRemove;
            window.basket.add({
              defer: true,
              variant,
              product,
              properties,
              quantity: newQuantity,
            });
            itemsToRemove = 0;
          } else if (quantity === itemsToRemove) {
            window.basket.remove(item.id);
            itemsToRemove = 0;
          } else {
            // this record doesn't have enough qty to finish the loop - remove and decrement
            window.basket.remove(item.id);
            itemsToRemove -= quantity;
          }
        });

        window.basket._update();
      }

      const planEvent = new CustomEvent('plan-v2:selected', {detail: {response: plan}});
      document.dispatchEvent(planEvent);

      this.refreshState(window.basket);
    };
    const modal = new tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ['button'],
      closeLabel: 'Close',
      cssClass: ['change-plan-modal'],
      onClose: () => {
        cartCleanup(modal.useSelectedPlan);
      },
    });
    modal.useSelectedPlan = false;

    modal.setContent(document.getElementById('change-content-modal').innerHTML);

    modal.addFooterBtn('Update Plan', 'continue-btn mosaic-cta-button text-center update-plan-modal-btn', () => {
      const confirmModal = new tingle.modal({
        footer: true,
        stickyFooter: false,
        closeMethods: ['button'],
        closeLabel: 'Close',
        cssClass: ['change-plan-confirm-modal'],
        onClose: () => {
          cartCleanup(confirmModal.useSelectedPlan);
        }
      });
      confirmModal.useSelectedPlan = false;

      confirmModal.setContent(document.getElementById('confirm-change-content-modal').innerHTML);

      document.querySelectorAll('.confirm-change-cart-count').forEach((element) => {
        element.innerHTML = `${window.basket.item_count} ${window.basket.item_count === 1 ? 'item' : 'items'}`;
      });
      document.querySelectorAll('.confirm-change-removal-count').forEach((element) => {
        const change = (window.basket.item_count - self.selectedPlan.itemQuantity);
        element.innerHTML = `${change} ${change === 1 ? 'item' : 'items'}`;
      });

      confirmModal.addFooterBtn('Cancel', 'continue-btn mosaic-cta-button text-center update-plan-modal-btn bg-white', () => {
        self.selectedPlan = originalPlan;
        confirmModal.close();
      });
      confirmModal.addFooterBtn('Confirm', 'continue-btn mosaic-cta-button text-center update-plan-modal-btn', () => {
        confirmModal.useSelectedPlan = true;
        confirmModal.close();
      });

      if (originalPlan !== self.selectedPlan && originalPlan.itemQuantity > self.selectedPlan.itemQuantity && self.selectedPlan.itemQuantity < window.basket.item_count) {
        modal.close();
        confirmModal.open();
      } else {
        modal.useSelectedPlan = true;
        modal.close();
      }
    });

    this.selectInitialPlan();
    const $section = $('.change-step-plan-selector-v2').last();
    $section.find('.selector-items-wrapper').on('keydown', processSelectPlanKeyPress);
    $section.find('.plan.selector-item').on('click', (e) => {
      const planId = $(e.currentTarget).data('id');
      this.selectPlan(planId);
    });


    $section.find('.continue-btn').on('click', (e) => {
      e.preventDefault();
    });

    modal.open();
    $section.find('.plan.selector-item')[0].focus();
  },

  refreshCartButton(total, orderMin, itemThreshold, itemCount) {
    let text = 'Continue',
      disabledState = true;
    const orderMinAlt = (themeConfiguration || {}).planConfiguration === 'splendid' ? 5 : 6;

    if (this.selectedPlan) {
      disabledState = window.basket.item_count !== this.selectedPlan.itemQuantity;
    } else if (itemThreshold && itemCount >= itemThreshold) {
      disabledState = false;
    } else if (itemCount >= orderMinAlt) {
      disabledState = false;
    }

    this.$nextStepBtn.html(text);
    this.$nextStepBtn.prop('disabled', disabledState);
  },

  updatePlanVariants() {
    if (window.basket) {
      window.basket.items.forEach((item) => {
        const product = window.mosaic.products.find((p) => p.id === item.product_id);
        const variant = util.getMealsVariant(product.variants);
        const quantity = item.quantity;
        const properties = item.properties;

        if (variant && item.id !== variant.id) {
          window.basket.remove(item.id);
        }
        window.basket.add({
          defer: true,
          variant,
          product,
          properties,
          quantity,
        });
      });

      window.basket._update();
    }
  },

  refreshMenu(cart, total, orderMax, itemThreshold, itemCount) {
    const self = this;
    const $btns = $('.add-to-box-btn:not(.disabled)');
    $btns.removeClass('qty-visible qty-add-disabled').text('Add to Box');
    $('.box-qty').hide();

    this.refreshAddToCartButtons($btns, itemCount);

    if (cart) {
      const familyMeals = cart.items.filter((i) => i.sku.includes('-FM-'));
      const familyMealCount = familyMeals.reduce((p, i) => p + i.quantity, 0);
      if (familyMealCount >= 8) {
        // remove last family item item from cart - we don't know last so we just decrement the last one
        cart.decrement(familyMeals.reverse()[0].id);

        this.openModal(document.getElementById('family-meal-limit-content-modal').innerHTML, this.familyPlanLimitModal);
      }

      cart.items.forEach((item, index) => {
        const line = index + 1;
        const $product = $(`[data-product-id=${item.product_id}]`);
        let sub;

        if (window.mosaic.recharge) {
          sub = window.mosaic.recharge.subscriptions.find((sub) => sub.shopify_product_id === item.product_id);
          self.$cartContinueBtn.html('Save Your Box'); // save order for existing customers
        }

        $product.find('.box-qty').css({display: 'inline-flex'});
        $product.find('[data-minus-one]').attr('data-minus-one', line).attr('data-new-qty', item.quantity - 1);
        $product.find('[data-plus-one]').attr('data-plus-one', line).attr('data-new-qty', item.quantity + 1);
        $product.find('.box-count').text(item.quantity);
        $product.find('.add-to-box-btn').text('Add Another').addClass('qty-visible');

        if (sub && item.quantity === sub.quantity) {
          const $limitedBtn = $product.find('.add-to-box-btn.limited-stock');
          $limitedBtn.text('Limited stock').addClass('qty-visible qty-add-disabled');

          if ($limitedBtn.length) {
            $(`[data-plus-one][data-product-id="${sub.shopify_product_id}"]`)
              .addClass('disabled');
          }
        }
      });
    }
  },

  refreshAddToCartButtons($btns, itemCount) {
    const $addToBox = $('.add-to-box');
    const $incrementBtns = $('[data-plus-one]');
    const orderMax = (themeConfiguration || {}).planConfiguration === 'splendid' ? 28 : 18;
    if (itemCount && itemCount >= orderMax) {
      $addToBox.addClass('disabled');
      $btns.attr('disabled', true).text('Box is full');
      $incrementBtns.addClass('disabled');
    } else {
      $addToBox.removeClass('disabled');
      $btns.attr('disabled', false);
      $incrementBtns.removeClass('disabled');
    }
  },

  chooseForMe(e) {

    /**
     * GTM - chooseForMe
     */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'chooseForMe',
    });

    const $cfmButton = $('#chooseForMe');
    const defaultShippingINtervalFreqncy = themeConfiguration ? themeConfiguration.defaultShippingFrequency : 2;
    let cartSubTotal = 0;
    let itemsAdded = 0;
    let frequency = util.getUrlParam('frequency', defaultShippingINtervalFreqncy);

    let productIds = $cfmButton.attr('data-cfm-product-list');
    frequency = Number(frequency);
    frequency === NaN ? frequency = defaultShippingINtervalFreqncy : null;

    // Strip trailing commas
    productIds = productIds.replace(/(^,)|(,$)/g, '');

    const excludeTag = `Exclude:${window.basket.getFulfillmentCenter()}`;
    // let { chooseForMeThreshold, itemThreshold } = this.refreshThresholds()

    // no limit for dollars - only quantity
    const chooseForMeThreshold = 999999;

     // existing users get 12
    let itemThreshold = 12;

    const availableCollections = util.getUrlParam(
      'show_categories',
      window.themeConfiguration.displayCollections.join(','),
    );
    const selectedOptions = this.getSelectedOptions();

    if (this.selectedPlan) {
      itemThreshold = this.selectedPlan.itemQuantity;
    }

    window.basket.empty();

    productIds.split(',').forEach((productId) => {
      const product = window.mosaic.products.find((p) => p.id === Number(productId));
      // Make sure meal appears in one of the available collections
      const isMealInAvailableCollections = product.collections.some(({handle}) => {
        return availableCollections.includes(handle);
      });
      // Make sure meal meets the requirements of the filters
      const isFilteredIn = selectedOptions.every((filter) => {
        return product.intro_metafields[filter] === 'true' ||
          (filter === 'under_450_cals' &&
            (product.nutrition_metafields.calories < 450 && product.nutrition_metafields.calories !== 0)
          );
      });
      // Make sure meal is not excluded by fulfillment center
      const isNotExcludedByFulfillment = !product.tags.includes(excludeTag);
      if (
        isFilteredIn &&
        isMealInAvailableCollections &&
        isNotExcludedByFulfillment &&
        (itemThreshold ? itemsAdded < itemThreshold : cartSubTotal < chooseForMeThreshold)
      ) {
        const variant = util.getMealsVariant(product.variants, 8);
        cartSubTotal += variant.price;

        window.basket.add({
          defer: true,
          variant,
          product,
          properties: {
            ...frequency == 0 ? {
              onetime: true,
            } : {
              subscription_id: product.subscription_product_id,
              shipping_interval_frequency: frequency,
              shipping_interval_unit_type: 'weeks',
            },
          },
          quantity: 1,
        });

        itemsAdded += 1;
      }
    });
    window.basket._update();

    // If the threshold isn't met, loop through cart items and increment
    if (itemsAdded) {
      while (itemThreshold ? itemsAdded < itemThreshold : cartSubTotal < chooseForMeThreshold) {
        window.basket.items.forEach((item) => {
          if (itemThreshold ? itemsAdded < itemThreshold : cartSubTotal < chooseForMeThreshold) {
            cartSubTotal += item.price;
            window.basket.increment({variantId: item.id, defer: true});
            itemsAdded += 1;
          }
        });
        window.basket._update();
      }
    }

    this.expandCartContainer();
  },

  addToBoxListeners(selector, modal) {
    $('body').on('click', selector, (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      let frequency = util.getUrlParam('frequency', 2);
      frequency = Number(frequency) || 2;

      const $btn = $(e.currentTarget).closest('.add-to-box');
      const productId = $btn.attr('data-product-id');
      const product = window.mosaic.products.find((p) => p.id === Number(productId));
      const variant = util.getMealsVariant(product.variants);
      window.basket.add({
        variant,
        product,
        properties: {
          ...frequency == 0 ? {
            onetime: true,
          } : {
            subscription_id: product.subscription_product_id,
            shipping_interval_frequency: frequency,
            shipping_interval_unit_type: 'weeks',
          },
        },
        quantity: 1,
      });

      /**
       * GTM - addToCart
       */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        productProperties: {
          product_title: product.title,
          product_id: product.id,
        },
      });
      window.Shopify.analytics.publish('mosaicAddToCart', {
        product_title: product.title,
        product_id: product.id,
      });

      if (modal.isOpen()) {
        modal.close();
      }
    });
  },

  instanciateModal(extraClasses = []) {

    return new tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: 'Close',
      cssClass: extraClasses,
      beforeClose(e) {
        if (extraClasses.join(',').includes('explainer')) {

          /**
           * GTM - closeMealSelectorModal
           */
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'closeMealSelectorModal',
          });
        }

        if (extraClasses.includes('meal-details-modal')) {
          const $content = $(this.modalBoxContent).find('.add-to-box');
          const productId = Number($content.attr('data-product-id'));
          const productTitle = $content.attr('data-product-title');

          /**
           * GTM - closeMealDetailsModal
           */
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'closeMealDetailsModal',
            productProperties: {
              product_title: productTitle,
              product_id: productId,
            },
          });
        }
        // e.g. save content before closing the modal
        $('.tingle-modal-box__content').scrollTop(0);
        return true; // close the modal
        return false; // nothing happens
      },
    });
  },

  attachModalListeners(modal) {


  },

  openModal(content, modal) {
    modal.setContent(content);
    modal.scrollTop = 0;
    // open modal
    modal.open();

    const self = this;
    // Run the updateFadeIns function on scroll
    $('.tingle-modal--overflow').bind('scroll', () => {
      animations.updateFadeIns('.tingle-modal--overflow');
    });

    util.initQuantityListeners('[data-plus-one]', '[data-minus-one]', $('.tingle-modal-box__content'));
    
    $('.cart-add-product, .add-to-box-btn').on('click', (e) => {
      if (window.basket && this.selectedPlan && window.basket.item_count >= this.selectedPlan.itemQuantity) {
        this.productIdToBeAdded = e.currentTarget.dataset.productId;
        e.preventDefault();
        this.showChangePlanModal();
      }
    });
    this.addToBoxListeners('.tingle-modal-box__content .add-to-box-btn', modal);
    $('.edit-frequency-button').click(() => {
      self.editSubscription(window.basket, $('.frequency-modal #subscription-frequency-selector').val());
      modal.close();
    });

    const event = new Event('carousel:init');

    // Dispatch the event.
    document.dispatchEvent(event);
    this.attachModalListeners(modal);
  },

  openMealDetailsModal(event) {

    const $meal = $(event.target).closest('.meal');
    const content = $meal.find('.more-info-modal')
    .html();

    const productId = Number($meal.attr('data-product-id'));
    const productTitle = $meal.attr('data-product-title');

    /**
     * GTM - viewMealDetailsModal
     */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'viewMealDetailsModal',
      productProperties: {
        product_title: productTitle,
        product_id: productId,
      },
    });
    this.openModal(content, event.data.modal);
  },

  applyFiltersFromURL() {
    const filters = ['vegetarian', 'vegan', 'wheat_free', 'nut_free', 'high_protein'];
    const urlFilters = util.getUrlParam('filters', '').replace('-', '_');
    const selectedOptions = [];

    filters.forEach((filter) => {
      const isFiltered = util.getUrlParam(filter, false);
      if (isFiltered || urlFilters.includes(filter)) {
        // Check the box on the drawer
        $(`input#filter-${filter}`).prop('checked', true);

        // Push option to filters
        selectedOptions.push(filter);
      }
    });

    // hide meals that do not have this filter
    this.filterMeals(selectedOptions, false);
  },

  getSelectedOptions() {
    const $filterStatusWrapper = $('.filter-status-wrapper');
    const $filterStatus = $('.filter-status');
    let filterStatusElements = '';
    const selectedOptions = [];

    $('#filters .drawer li input:checked').each((_, input) => {
      const $input = $(input);
      const text = $(`label[for="${$input.attr('id')}"]`).text();
      const dataFilter = $input.data('filter');
      filterStatusElements += `<span data-filter-status="${dataFilter}" tabindex="0"><i class="fa fa-times-circle"></i>${text}</span>`;
      selectedOptions.push(dataFilter);
    });

    if (filterStatusElements) {
      $filterStatusWrapper.fadeTo(300, 1, () => {
        $filterStatus.html(filterStatusElements);
        $filterStatusWrapper.height('auto');
      });
    } else {

      $filterStatusWrapper.fadeTo(300, 0, () => {
        $filterStatusWrapper.height(0);
      });
    }

    return selectedOptions;
  },

  filterMeals(selectedOptions, showRefresh = false) {
    const self = this;
    let filterSelector = '.meal';

    if (selectedOptions.includes('vegetarian')) {
      selectedOptions.push('vegan');
    }

    // For each option, add to our selector and filters HTML string
    selectedOptions.forEach((option) => {
      filterSelector += `[data-filter-${option}]`;
    });

    // Hide meals that do not have this filter
    $('.meal').css('display', 'none');
    $(filterSelector).css('display', 'flex');

    // If showRefresh is toggled, show the reloading sign for a second before finishing
    if (showRefresh) {
      // Show the refresh symbol
      $('.meal-collection').hide();
      $('.panel-faq').hide();

      $('#meal-list-refresh').show();

      setTimeout(() => {
        // After a short delay, show the meal list
        self.refreshCategories();
        $('.panel-faq').hide();
        $('#meal-list-refresh').hide();
        // reset collection nav
        self.setCollectionNav(0);
      }, 500);
    }

    if (window.shopifyCustomer && window.location.href.indexOf('meal-editor') > -1) {
      var orderType = 'recurring_charge';
    } else {
      var orderType = 'new';
    }
    // filter fulfillment center exclusions
    let fulfillmentCenterCode = window.basket.getFulfillmentCenter();
    if (fulfillmentCenterCode) {
      const $oos = $(`[data-fc-excludes-${fulfillmentCenterCode.toLowerCase()}]`);
      // out of stock
      $oos.find('.add-to-box').addClass('out-of-stock');
      $oos.find('.meal-img').addClass('disabled-opacity');
      $oos.find('.add-to-box-btn').text('Out of Stock').addClass('disabled')
        .prop('disabled', true);
      $oos.find('.box-qty').hide();
    } else {
      const zip = util.getUrlParam('zip_code');
      if (zip) {
        util.checkAvailability({
          emptyBasket: false,
          shipping_zipcode: zip,
          order_type: orderType,
          errorCallback(err) {
            console.log('error', err);
          },
          completeCallback(res) {
            if (res.fc_shortcode) {
              window.basket.setFulfillmentCenter(res.fc_shortcode);
              fulfillmentCenterCode = res.fc_shortcode;
              const $oos = $(`[data-fc-excludes-${fulfillmentCenterCode.toLowerCase()}]`);
              // out of stock
              $oos.find('.add-to-box').addClass('out-of-stock');
              $oos.find('.meal-img').addClass('disabled-opacity');
              $oos.find('.add-to-box-btn').text('Out of Stock').addClass('disabled')
                .prop('disabled', true);
              $oos.find('.box-qty').hide();
            }
            if (res.display_shipping || res.display_shipping_smallest_plan) {
              window.basket.setDisplayShipping(res.display_shipping || res.display_shipping_smallest_plan);
            }
          },
        });
      }
    }
  },

  setCollectionNav(windowTop) {
    $('.meal-collection').each((index, element) => {
      const position = $(element).offset().top;
      const height = $(element).outerHeight(true);
      const handle = $(element).data('handle');
      const buffer = 55;
      if ((windowTop > (position - buffer)) && (windowTop < (position + height - buffer))) {
        $(`#collection-links a[data-handle="${handle}"]`).addClass('active');
      } else {
        $(`#collection-links a[data-handle="${handle}"]`).removeClass('active');
      }
    });
  },

  getCartTotal(cart) {
    return cart && cart.items.reduce((sum, item) => { return sum + (item.price * item.quantity); }, 0);
  },

  refreshState(basket, options = {}) {
    const {initialLoad} = options;
    const {orderMin, orderMax, itemThreshold} = this.refreshThresholds();
    const total = this.getCartTotal(basket);
    const itemCount = basket.item_count;

    if (initialLoad) {
      const frequency = util.getUrlParam('frequency');
      const checkout = util.getUrlParam('checkout');

      if (['0', '1', '2', '3', '4'].includes(frequency)) {
        util.updateFrequency(frequency);
      }

      if (frequency === '0' && checkout == 'shopify') {
        this.$changePlanButton.hide();
      } else {
        this.$changePlanButton.show();
      }
    }

    if (this.selectedPlan) { this.updateItemQuantities(); }
    this.refreshCart(basket, total, orderMin, itemThreshold, itemCount);
    this.refreshMenu(basket, total, orderMax, itemThreshold, itemCount);
  },

  refreshCategories() {
    // Sort Url Categories
    const fcDateAttr = `data-fc-excludes-${window.basket.getFulfillmentCenter()}`;
    const categoryParams = util.getUrlParam('category_order', false);
    const defaultCategoryOrder = window.themeConfiguration.displayCollections;

    if (categoryParams) {
      let categoryOrder = decodeURIComponent(categoryParams).split(',');
      // Handle incomplete param list
      if (categoryOrder.length < defaultCategoryOrder.length) {
        categoryOrder.forEach((el, i) => {
          categoryOrder[i] = el.split('#')[0];
          const index = defaultCategoryOrder.indexOf(el);
          defaultCategoryOrder.splice(index, 1);
        });
        categoryOrder = categoryOrder.concat(defaultCategoryOrder);
      }

      this.sortCategories(categoryOrder);
    }

    // Hide unused flow categories
    const categoriesToShow = util.getUrlParam('show_categories');
    if (categoriesToShow) {
      $('#collection-links a').hide();
      $('.meal-collection').hide();
      decodeURIComponent(categoriesToShow).split(',').forEach((handle) => {
        $(`#collection-links [data-handle="${handle}"]`).show();
        $(`.meal-collection[data-handle="${handle}"]`).show();
      });
    } else {
      $('#collection-links a').each((index, el) => {
        const attr = el.attributes[fcDateAttr];
        const isExcluded = (attr && attr.name);
        isExcluded ? $(el).hide() : $(el).show();
      });

      $('.meal-collection').each((index, el) => {
        const attr = el.attributes[fcDateAttr];
        const isExcluded = (attr && attr.name);
        isExcluded ? $(el).hide() : $(el).show();
      });
    }
  },

  sortCategories(categoryOrder) {
    const items = this.$container.find('.meal-collection');
    const navItems = this.$container.find('#collection-links a');
    const hashMap = Array.from(items).reduce((acc, el) => {
      if (categoryOrder.indexOf(el.dataset.handle) === -1) {
        categoryOrder.push(el.dataset.handle);
      }
      acc[el.dataset.handle] = {
        html: el.innerHTML,
        handle: el.dataset.handle,
        navItem: $(`#collection-links a[data-handle="${el.dataset.handle}"]`).html(),
      };
      return acc;
    }, {});

    const sortedArray = categoryOrder.map((handle) => hashMap[handle]);

    // Order Collection Lists
    $.each(items, (index, el) => {
      el.innerHTML = sortedArray[index].html;
      el.dataset.handle = sortedArray[index].handle;
    });
    // Order Nav Elements
    $.each(navItems, (index, el) => {
      el.innerHTML = sortedArray[index].navItem;
      el.href = `#${sortedArray[index].handle}`;
      el.dataset.handle = sortedArray[index].handle;
    });
  },

  addVariantsToBasket(variants, frequency = 4) {
    for (let i = window.mosaic.products.length; i--;) {
      const product = window.mosaic.products[i];
      const variant = product.variants.find((variant) => {
        return variants.includes(variant.id);
      });

      if (product && variant) {
        const quantity = (variants.split(variant.id).length - 1);

        window.basket.add({
          defer: true,
          variant,
          product,
          properties: {
            ...frequency == 0 ? {
              onetime: true,
            } : {
              subscription_id: product.subscription_product_id,
              shipping_interval_frequency: frequency,
              shipping_interval_unit_type: 'weeks',
            },
          },
          quantity,
        });
      }
    }
    window.basket._update();
  },

  autoAddMeals() {
    // Add prepopulated meals from Optimize
    const prepopulatedMeals = window.basket.getOptimizeProperty('prepopulatedMeals');
    if (prepopulatedMeals && prepopulatedMeals.length) {
      const frequency = window.basket.getOptimizeProperty('frequency');
      window.basket.empty();
      this.addVariantsToBasket(prepopulatedMeals, frequency);
    }

    // Auto Add Meals from URL
    const autoAddMeals = util.getUrlParam('auto_add_meals');

    if (autoAddMeals && autoAddMeals.length) {
      let frequency = util.getUrlParam('frequency', window.basket.getOptimizeProperty('frequency'));
      frequency = ['0', '1', '2', '3', '4'].includes(frequency) ? frequency : '4';
      window.basket.empty();
      console.info('Auto Add Meals from URL', autoAddMeals, frequency, window.basket);
      this.addVariantsToBasket(autoAddMeals, frequency);
      console.info(window.basket);
    }
  },

  updateItemQuantities() {
    const quantityText = `${window.basket.item_count}/${this.selectedPlan.itemQuantity}`;
    this.$cartContainer.find('.item-quantity').text(quantityText);
    $('.selected-plan-meal-count').text(this.selectedPlan.itemQuantity);
  },

  async onLoad() {
    this.$container = $('#choose-your-meals');
    this.$nextStepBtn = this.$container.find('.next-step');
    this.$freeShippingGaugeWrapper = $('.shipping-gauge-wrapper');
    this.$freeShippingProgress = $('.shipping-gauge .progress');
    this.$freeShippingText = $('.shipping-gauge-text');
    this.$cartContinueBtn = $('#meal-cart-continue');
    this.$cartContainer = $('#cart-container');
    this.$mealCart = $('#meal-cart');
    this.$chooseForMeWrapper = $('.choose-for-me-wrapper');
    this.$cartItemCountContainer = $('#cart-item-count, #header-item-count');
    this.$cartItemCountMobileContainer = $('#cart-item-count-mobile');
    this.$cartProgressBarSpan = $('.bmsm-bar');
    this.$clearBoxButton = $('#clear-box');
    this.$changePlanButton = $('#change-plan-size');

    document.addEventListener('plan-v2:selected', (e) => {
      const {response, initial} = e.detail;
      this.selectedPlan = response;
      if (!initial) { return; }
      this.refreshState(window.basket);
      this.autoAddMeals();
      this.refreshCategories();
      this.applyFiltersFromURL();
    });

    const self = this;
    util.clearCart();

    if (window.mosaic.views && window.mosaic.views.state.flow === 'plansV2') {
      $('#cart-container').addClass('with-plan');
      $('#meal-collection-list').addClass('with-plan');
    }

    if (window.shopifyCustomer && window.location.href.indexOf('meal-editor') > -1) {
      window.basket.empty();
      rechargeUtil.getRechargeData(async () => {
        // Check fulfillment center
        const zip = window.mosaic.recharge && window.mosaic.recharge.addresses[0].zip;
        if (zip) {
          util.checkAvailability({
            shipping_zipcode: zip,
            order_type: 'recurring_charge',
            errorCallback(err) {
              console.log('Check Availability error', err);
            },
            async completeCallback(res) {
              if (res.fc_shortcode) {
                window.basket.setFulfillmentCenter(res.fc_shortcode);

                // Handle Limited Stock
                const $oos = $(`[data-fc-excludes-${res.fc_shortcode.toLowerCase()}]`);
                window.mosaic.recharge.subscriptions.forEach((sub) => {
                  $oos.filter(`[data-product-id="${sub.shopify_product_id}"]`).find('.meal-img').removeClass('disabled-opacity');
                  $oos.find(`.cart-add-product[data-product-id="${sub.shopify_product_id}"]`)
                    .attr('data-limited-stock', sub.quantity)
                    .addClass('limited-stock')
                    .removeClass('disabled');

                  $oos.find(`[data-product-id="${sub.shopify_product_id}"] .add-to-box-btn`)
                    .attr('data-limited-stock', sub.quantity)
                    .addClass('limited-stock')
                    .removeClass('disabled');
                  $oos.find('.meal-img').attr('data-limited-stock', sub.quantity);
                  $oos.find(`.add-to-box[data-product-id="${sub.shopify_product_id}"]`).attr('data-limited-stock', sub.quantity);
                });
              }

              const {itemThreshold} = self.refreshThresholds();
              await util.addSubscriptionsToCart(itemThreshold);
            },
          });
        } else {
          const {itemThreshold} = self.refreshThresholds();
          await util.addSubscriptionsToCart(itemThreshold);
        }
      });
    } else if (window.location.href.indexOf('frequency=0') > -1) {
      window.basket.setOptimizeProperty('frequency', '0');
    }

    // Auto Add Meals
    this.autoAddMeals();

    document.addEventListener('basket:init', (e) => {
      const {response} = e.detail;
      this.refreshState(response);
    });
    document.addEventListener('basket:updated', (e) => {
      const {response} = e.detail;
      this.refreshState(response);
    });
    document.addEventListener('step:choose-your-meals', (e) => {
      const zip = util.getUrlParam('zip_code');
      // Initialize Explanation Modal
      const itemThreshold = util.getUrlParam('build_to_num');
      const explainerModalContent = $('#explainer-modal').html();

      if (this.planVariation != 'B') {
        if (
          window.location.href.indexOf('meal-editor') === -1 &&
          window.location.href.indexOf('skip_meal_selector=true') === -1 &&
          window.location.href.indexOf('checkout=true') === -1
        ) {
          if (zip) {
            if (itemThreshold) {
              const frequency = util.getUrlParam('frequency');
              $('#family-explainer-modal').find('.js-meals').text(`${itemThreshold}`);

              if (frequency == 0) {
                $('#family-explainer-modal').find('[data-js-plan] .explainer-modal-instruction-headline h3').text('One-off order');
                $('#family-explainer-modal').find('[data-js-plan] p').text('You are placing a one-off order, with no subscriptions necessary!');
              }
              const familyExplainerModalContent = $('#family-explainer-modal').html();
              self.openModal(familyExplainerModalContent, familyExplainerModal);
            } else if (window.mosaic.views.state.flow === 'custom') {
              // self.openModal(explainerModalContent, explainerModal);
            }
          }
        }
      }
    });
    document.addEventListener('plan:selected', (e) => {
      const {response} = e.detail;
      this.refreshState(window.basket);
      this.autoAddMeals();
      this.refreshCategories();
      this.applyFiltersFromURL();
    });

    const frequencyModal = this.instanciateModal(['frequency-modal', 'mosaic-modal']);

    this.refreshCategories();

    $('.cart-add-product').on('click', (e) => {
      if (window.basket && this.selectedPlan && window.basket.item_count == this.selectedPlan.itemQuantity) {
        this.productIdToBeAdded = e.currentTarget.dataset.productId;
        e.preventDefault();
        this.showChangePlanModal();
      }
    });

    if (this.$clearBoxButton) {
      this.$clearBoxButton.click((e) => {
        e.preventDefault();
        if (window.basket) { window.basket.empty(); }
      });
    }
    if (this.$changePlanButton) {
      this.$changePlanButton.click((e) => {
        e.preventDefault();
        this.showChangePlanModal();
      });
    }


    this.$nextStepBtn.click((e) => {
      e.preventDefault();

      this.contractCartContainer();

      if (this.selectedPlan && this.selectedPlan.itemQuantity !== window.basket.item_count) {
        console.error('Basket item quantity does not meet plan requirements');
        return;
      }

      if (window.mosaic.recharge) {
        this.$nextStepBtn.addClass('disabled').attr('disabled', true);
        if (util.getSubscriptionFrequency(window.mosaic.recharge.subscriptions)) {
          self.editSubscription(window.basket);
        } else {
          const frequencyModalContent = $('#frequency-modal').html();
          self.openModal(frequencyModalContent, frequencyModal);
        }
        util.savingAnimation('.continue-to-checkout-main', 'Saving');
      } else {

        util.buttonToProcessingState(self.$cartContinueBtn, 'Adding to cart...');
        setTimeout(() => {
          util.buttonToCompletedState(self.$cartContinueBtn, 'Added!');

          setTimeout(() => {
            const flow = window.mosaic.views.state.flow;
            const nextStep = window.mosaic.views.flows[flow].map((view) => view[0]).indexOf('meal-menu') + 2;

            // START: A/B test force optimize cadence
            const optimizeFrequency = window.basket.getOptimizeProperty('frequency');
            if (optimizeFrequency && util.isFrequency(optimizeFrequency)) {

              if (optimizeFrequency == 0) {
                // Remove subscription properties
                window.basket.items.forEach((item, index) => {
                  const properties = item.properties;
                  properties.onetime = true;
                  delete properties.subscription_id;
                  delete properties.shipping_interval_unit_type;
                  delete properties.shipping_interval_frequency;
                  delete properties.charge_delay;
                  util.updateItemProps({properties, index, item, defer: true});
                });

                window.basket._update();
              } else {
                util.updateFrequency(optimizeFrequency);
              }
            } else {
              const frequency = util.getUrlParam('frequency');

              if (['0', '1', '2', '3', '4'].includes(frequency)) {
                util.updateFrequency(frequency);
              }
            }
            // END: A/B test force optimize cadence

            window.mosaic.views.nextStep(flow, nextStep, () => {

              /**
               * GTM - selectProducts
               */

              window.dataLayer = window.dataLayer || [];
              const productsPayload = window.basket.items.map(({product_id, product_title, quantity}) => ({product_id, product_title, quantity}));
              window.dataLayer.push({
                event: 'selectProducts',
                cartProperties: {
                  products: productsPayload,
                },
              });
              window.Shopify.analytics.publish('mosaicSelectProducts', {products: productsPayload});

              // update history for back button
              util.insertUrlParam('step', `${nextStep}`);
              util.buttonToNormalState(self.$cartContinueBtn, 'Continue');
            });
          }, 500);
        }, 500);
      }
    });

    this.refreshState(window.basket, {initialLoad: true});

    $('.your-box .your-box-header').click(() => {
      if (!self.$cartContainer.hasClass('expanded')) {
        self.expandCartContainer();
      } else {
        self.contractCartContainer();
      }
    });

    // Close modals on close button click
    $(document).on('click', '.tingle-modal__closeIcon', (e) => {
      if (explainerModal.isOpen()) {
        explainerModal.close();
      }
      if (familyExplainerModal.isOpen()) {
        familyExplainerModal.close();
      }
      if (modal.isOpen()) {
        modal.close();
      }
      if (this.familyPlanLimitModal.isOpen()) {
        this.familyPlanLimitModal.close();
      }
    });

    // apply filters from url parameters
    this.applyFiltersFromURL();


    // Underline Collection Link When Clicked
    $('.collection-links a').on('click', (evt) => {
      $('.collection-links a').removeClass('active');
      $(evt.currentTarget).addClass('active');
    });

    // When close button is pressed
    $('#filters [data-js-close-filters]').click(() => {
      $('#filters #menu-opener').prop('checked', false);
    });

    // When a drawer a link is clicked, check its box and refresh filters
    $('#filters .drawer li input').on('change', (e) => {
      self.filterMeals(self.getSelectedOptions(), true);
      // Report filter use to analytics
      window.Shopify.analytics.publish('mosaicFilterMeals', {
        filter: e.target.dataset.filter,
      });
    });

    // When the clear button is clicked, clear all checkboxes
    $('#filters [data-js-clear-filters]').click((e) => {
      e.preventDefault();
      $('#filters .drawer li input').prop('checked', false);
      self.filterMeals(self.getSelectedOptions(), true);
      $('#filters #menu-opener').prop('checked', false);
    });

    // Clear active filters in status bar
    $('.filter-status').on('click', (e) => {
      const dataFilter = e.target.dataset.filterStatus;
      if (dataFilter) {
        $(`#filter-${dataFilter}`).prop('checked', false);
        self.filterMeals(self.getSelectedOptions(), true);
      }
    });

    $('#menu-opener').on('change', (e) => {
      const checked = e.target.checked;
      const $filterMenu = $('#filters');
      const $filterChildren = $filterMenu.find('.tab-when-visible');

      $filterMenu.toggleClass('open', checked);
      $filterMenu.prop('aria-hidden', !checked);
      $filterChildren.prop('tabindex', checked ? 0 : -1);

      if (checked) {
        $filterChildren.first().trigger('focus');
      }
    });
    
    $('button.open-menu-button').on('click', (e) => {
      e.preventDefault();
      $('#filters #menu-opener').trigger('click');
    });

    // Sticky Meal Collection Nav to top when scrolled to, and set links when scrolling
    $(window).scroll(function() {
      const windowTop = $(this).scrollTop();
      self.setCollectionNav(windowTop);
    });

    const modal = this.instanciateModal(['mosaic-modal', 'meal-details-modal']);
    const explainerModal = this.instanciateModal(['explainer-modal', 'mosaic-modal']);
    const familyExplainerModal = this.instanciateModal(['family-explainer-modal', 'mosaic-modal']);
    this.familyPlanLimitModal = this.instanciateModal(['family-plan-limit-modal', 'mosaic-modal']);

    // Close modals when back button is clicked
    window.addEventListener('popstate', (ev) => {
      modal.close();
      explainerModal.close();
      familyExplainerModal.close();
      this.familyPlanLimitModal.close();
    });

    $(document).on(
      'click',
      '.meal-img, .meal-details',
      {modal},
      (e) => self.openMealDetailsModal.bind(self)(e),
    );

    $('.meal').on(
      'keydown',
      {modal},
      (e) => {
        if (!e.target.classList.contains('meal')) { return; }
        if (e.key === 'Enter' || e.key === ' ') {
          self.openMealDetailsModal.bind(self)(e);
        }
      },
    );

    util.initQuantityListeners('[data-plus-one]', '[data-minus-one]', this.$container);
    animations.attachAccordionListeners();

    $('#chooseForMe').click(self.chooseForMe.bind(this));

    this.addToBoxListeners('.add-to-box-btn', modal);

    document.getElementById('cart-container').addEventListener('swiped-up', (e) => {
      if (!self.$cartContainer.hasClass('expanded')) {
        self.expandCartContainer();
      }
    });

    document.getElementById('cart-container').addEventListener('swiped-down', (e) => {
      if (self.$cartContainer.hasClass('expanded')) {
        self.contractCartContainer();
      }
    });

    $('a.collection-link').on('click', (evt) => {
      const collectionHandle = $(evt.target).data('handle');
      $(`.meal-collection[data-handle="${collectionHandle}"]`).find('li.meal')[0].focus();
    });

    // Since all cart items are deleted and re-created when the cart is modified, we need to
    // re-attach focus to the quantity modification buttons in the cart; clicking one of these
    // buttons destroys it.
    this.$cartContainer.on('click', 'button.modify-meal-quantity', (evt) => {
      const productId = $(evt.target).data('productId');
      const action = evt.target.classList.contains('subtract') ? 'subtract' : 'add';
      console.info('Modify button clicked', productId, action);

      $(document).one(
        'cart:updated',
        {productId, action},
        (innerEvt) => {
          $(`.modify button[data-product-id="${innerEvt.data.productId}"].${innerEvt.data.action}`).trigger('focus');
        },
      );
    });
  },
});
